import { render } from "./setterComponent.vue?vue&type=template&id=66e5ca52&scoped=true"
import script from "./setterComponent.vue?vue&type=script&lang=js"
export * from "./setterComponent.vue?vue&type=script&lang=js"

import "./setterComponent.vue?vue&type=style&index=0&id=66e5ca52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e5ca52"]])

export default __exports__